import React, { useContext } from 'react';

import { UserContext } from './hooks/UserContext';
import Header from './components/Header';
import AiModelsSection from './components/settings/AiModelsSection';
import { isAdmin } from './services/jwtRoles';
import './components/settings/settings.css';

// Admin-only settings. Editors never see the menu item; anyone who lands
// here by URL without the role gets a plain notice (the API refuses too).
export const Settings = () => {
    const { user } = useContext(UserContext);
    const token = user ? user.token : '';

    return (
        <div className="App">
            <Header />
            <div className="st-page">
                <div className="row mt-4">
                    <div className="col-12 text-center">
                        <h2>Settings</h2>
                    </div>
                </div>
                {isAdmin(token)
                    ? <AiModelsSection token={token} />
                    : <p className="st-locked text-center">Settings are available to admins only.</p>}
            </div>
        </div>
    );
};

export default Settings;
